<template>
  <PageTemplate title="Contato">
    <v-sheet
      color="transparent"
      class="mx-auto d-flex flex-column flex-md-row justify-center"
    >
      <SectionTemplate
        title="Formulário"
        title-align="left"
        no-container
        no-padding
      >
        <ContactForm
          :action="server + formAction"
          response-to="/contato/obrigado"
        />
      </SectionTemplate>
      <SectionTemplate
        class="mt-4 mt-md-0 ml-md-4"
        title="Informações"
        title-align="left"
        no-container
        no-padding
      >
        <ContactWidget />
      </SectionTemplate>
    </v-sheet>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../components/templates/PageTemplate.vue";
import SectionTemplate from "../components/templates/SectionTemplate.vue";
import ContactForm from "../components/forms/ContactForm.vue";
import ContactWidget from "../components/widgets/ContactWidget.vue";

export default {
  data: () => ({
    formAction: "/rest/email/contact-us",
  }),
  components: {
    PageTemplate,
    SectionTemplate,
    ContactForm,
    ContactWidget,
  },
};
</script>
